import React, { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import { FaChevronUp } from 'react-icons/fa';
import { MdOutlineCheck } from 'react-icons/md';
import { Combobox } from '@headlessui/react';
import { InputLabelContainer } from '../../label/containers/input-label.container';

export function MultiSelectComponent({
  label,
  filtered,
  open,
  onValueChange,
  isDisabled,
  query,
  setQuery,
  onInputValueChange,
  selected,
  handleButtonClick,
  displaySelected,
  isRequired,
  multiple,
  toggleSelection,
}: any) {

  return (
    <div>
      <InputLabelContainer isRequired={isRequired} label={label} />
      <Combobox value={selected} onChange={onValueChange} multiple={multiple}>
        <div className="relative mt-1">
          <div>
            <Combobox.Input
              className={`w-full pl-4 pr-7 py-2 border rounded-md ${
                isDisabled
                  ? 'bg-gray-200 cursor-not-allowed'
                  : 'bg-white hover:border-gray-400 focus:outline-none focus:border-blue-500'
              }`}
              displayValue={displaySelected}
              onChange={onInputValueChange}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2" onClick={handleButtonClick}>
            <FaChevronUp className={`h-4 w-4 text-gray-400 text-center transform ${open ? 'rotate-180' : ''}`} />
</Combobox.Button>
          </div>

          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
           <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10">

  {selected.map((selectedItem: any) => (
    <Combobox.Option
      key={selectedItem.value}
  className={({ active }) =>
  `relative cursor-default select-none py-2 pl-10 pr-4 ${
    active ? 'bg-skin-ouprimary' : 'text-skin-ouprimary'
  }`
}
      value={selectedItem}
      onSelect={() => toggleSelection(selectedItem)}
      
    >
       {({ selected, active }) => (
        <>
          <span
                          className={`block truncate ${
                            selected ? 'font-medium' : 'font-normal'
                          }`}
                        >
                          {selectedItem?.label}
                          </span>
                          {selected ? (
          <span 
         
          className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
            active ? 'text-white' : 'text-skin-ouprimary'
          }`}
          >
            <MdOutlineCheck className="h-5 w-5" aria-hidden="true" />
          </span>
           ) : null}
        </>
      )}
    </Combobox.Option>
  ))}
 

     {filtered.length === 0 && query !== '' ? (
      <div className="relative cursor-default select-none px-4 py-2 text-gray-700">Nothing found.</div>
    ) : (
  filtered.map((data: any) => {
    if (!selected.find((p: any) => p.value === data.value)) {
      return (
        
        <Combobox.Option
          key={data.value}
          className={({ active }) =>
          `relative cursor-default select-none py-2 pl-10 pr-4 ${
            active ? 'bg-skin-ouprimary' : 'text-skin-ouprimary'
          }`
        }
          value={data}
          onSelect={() => toggleSelection(data)}
        >
          {({ selected: isSelected, active }) => (
            <>
              <span className={`block truncate ${isSelected ? 'font-medium' : 'font-normal'}`}>{data.label}</span>
              {isSelected ? (
                <span className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-skin-ouprimary' : 'text-white'}`}>
                  <MdOutlineCheck className="h-5 w-5" aria-hidden="true" />
                </span>
              ) : null}
            </>
          )}
        </Combobox.Option>
      );
    }
    return null;
  }))}
</Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
}
